import React from 'react';
import classNames from 'classnames';
import warningIcon from './assets/warning-icon.svg';
import './styles.css';

const Warning = ({className, children}: any) => (
  <div className={classNames('Warning', className)}>
    <img src={warningIcon} className="warningIcon" alt="warning" />
    <div className="message">{children}</div>
  </div>
);

export default Warning;
